module.exports = __webpack_public_path__ + "img/icon-eraser.fc331602.png";